import React, { useEffect, useState } from "react";
import Header from "../Header";
import Footer from "../Footer";
import useParentHeaderFooter from "@/hooks/useParentHeaderFooter";
import SEO from "@/components/Seo";
import {
  selectParentHeaderAndFooterData,
  setParentHeaderAndFooterData,
} from "@/redux/dataSlice";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { PARENT_HEADER_AND_FOOTER } from "@/utils/constants";
import router from "next/router";

const CommonLayout = ({ children, additionalProp }: any) => {
  const [commonData, setCommonData] = useState(null);
  const dispatch = useDispatch();
  const getHeaderData = useSelector(selectParentHeaderAndFooterData);

  useEffect(() => {
    const fetchData = async () => {
      let attempts = 0;
      const maxAttempts = 2;

      while (attempts < maxAttempts) {
        try {
          const data = await useParentHeaderFooter(PARENT_HEADER_AND_FOOTER);
          if (data?.data) {
            dispatch(setParentHeaderAndFooterData(data));
            setCommonData(data);
            break;
          }
        } catch (error) {
          console.error("error --->", error);
        }
        attempts++;
      }

      if (attempts === 2) {
        router.push({
          pathname: "/parent/login",
          query: {
            errorIntent: "Something went wrong. Login to continue...",
          },
        });
      }
      
    };

    if (getHeaderData) {
      setCommonData(getHeaderData);
    } else {
      fetchData();
    }
  }, []);

  return (
    <>
      <Header data={commonData} />
      <SEO title={additionalProp} />
      {children && <div>{children}</div>}
      <Footer data={commonData} />
    </>
  );
};

export default CommonLayout;
